export interface InsidePage {
  src: string
  tomo: string
  title: string
}

/** Páginas reales del interior del manual (formato A4 vertical). */
export const INSIDE_PAGES: InsidePage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/gyYzpXph4BvnytE5w1jg2P/01_Tomo1_p07_Como_derretir_la_base.png',
    tomo: 'Tomo 1',
    title: 'Cómo derretir la base',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/i8bnBe8YNZuhqDngSmsfTu/02_Tomo1_p15_Formula_Cafe_Espresso.png',
    tomo: 'Tomo 1',
    title: 'Fórmula Café Espresso',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/rP7YyCHfYhtsEK6W3r9Nak/03_Tomo2_p12_Swirl_Tricolor.png',
    tomo: 'Tomo 2',
    title: 'Swirl Tricolor',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/4AtVLSbUxNzUh62MBvGWqA/04_Tomo2_p27_Cinco_Capas_Minimalista.png',
    tomo: 'Tomo 2',
    title: 'Cinco Capas Minimalista',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/hvFXTUMuM72NmSpcXJEi12/05_Tomo3_p27_Helados_Paletas_Postres_Frios.png',
    tomo: 'Tomo 3',
    title: 'Helados, Paletas & Postres Fríos',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/wjraEcg6je9KL2uM2C58gi/06_Tomo4_p39_Regalos_Corporativos_Multiusos.png',
    tomo: 'Tomo 4',
    title: 'Regalos Corporativos & Multiusos',
  },
]

export const INSIDE_PAGES_POINTS: string[] = [
  'Aprendé técnicas base paso a paso',
  'Descubrí fórmulas creativas y diseños vendibles',
  'Inspirate con ideas para regalar, emprender y diferenciarte',
]
